<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Monitoramento</div>
</div>

@for (item of noShows; track item.noShow!.id) {
  <div class="noshow-banner">
    <mat-icon>block</mat-icon>
    <span>
      <b>No-show registrado</b> — {{ item.codigoTg }} · {{ item.cliente }}
      @if (item.noShow!.detalhe) { · {{ item.noShow!.detalhe }} }. Consultora notificada.
    </span>
    <button class="btn-icon" (click)="dispensarBanner(item.noShow!.id)"><mat-icon>close</mat-icon></button>
  </div>
}

<mat-tab-group [selectedIndex]="aba === 'ativos' ? 0 : 1" (selectedIndexChange)="onTab($event === 0 ? 'ativos' : 'finalizados')">
  <mat-tab [label]="'Ativos'"></mat-tab>
  <mat-tab [label]="'Finalizados'"></mat-tab>
</mat-tab-group>

<div class="flex items-center gap-3 my-3 flex-wrap">
  <mat-form-field class="input-tg search-tg mt-message-input w-[240px]" appearance="outline">
    <mat-label>Código da OS</mat-label>
    <input matInput [(ngModel)]="codigoOs" (keyup.enter)="onBusca()" placeholder="TG26-5269 ou TG26-5269-0011" />
    @if (codigoOs) {
      <button mat-icon-button matSuffix (click)="onLimparCodigoOs()"><mat-icon>close</mat-icon></button>
    }
  </mat-form-field>
  <mat-form-field class="input-tg search-tg mt-message-input flex-1 min-w-[260px]" appearance="outline">
    <mat-label>Buscar por TG, cliente, motorista, passageiro ou percurso...</mat-label>
    <input matInput [(ngModel)]="busca" (keyup.enter)="onBusca()" />
    @if (busca) {
      <button mat-icon-button matSuffix (click)="onLimparBusca()"><mat-icon>close</mat-icon></button>
    }
  </mat-form-field>
  <button class="btn-icon" (click)="onBusca()" matTooltip="Buscar"><mat-icon>search</mat-icon></button>
  <button class="btn-icon" (click)="abrirFiltrosAvancados()" matTooltip="Filtros avançados">
    <mat-icon>tune</mat-icon>
  </button>
</div>

<div class="flex gap-2 flex-wrap mb-3">
  <button type="button" class="chip-filtro" [ngClass]="statusFarolAtivo === null ? 'chip-filtro--active' : ''"
    (click)="onChipStatus(null)">Todos<span class="chip-filtro-count">{{ resumo?.servicosHoje ?? 0 }}</span></button>
  <button type="button" class="chip-filtro chip-filtro--no_prazo" [ngClass]="statusFarolAtivo === 'no_prazo' ? 'chip-filtro--active' : ''"
    (click)="onChipStatus('no_prazo')">No prazo<span class="chip-filtro-count">{{ resumo?.noPrazo ?? 0 }}</span></button>
  <button type="button" class="chip-filtro chip-filtro--alerta" [ngClass]="statusFarolAtivo === 'alerta' ? 'chip-filtro--active' : ''"
    (click)="onChipStatus('alerta')">Alerta<span class="chip-filtro-count">{{ resumo?.alerta ?? 0 }}</span></button>
  <button type="button" class="chip-filtro chip-filtro--critico" [ngClass]="statusFarolAtivo === 'critico' ? 'chip-filtro--active' : ''"
    (click)="onChipStatus('critico')">Crítico<span class="chip-filtro-count">{{ resumo?.critico ?? 0 }}</span></button>
  <button type="button" class="chip-filtro chip-filtro--no_show" [ngClass]="statusFarolAtivo === 'no_show' ? 'chip-filtro--active' : ''"
    (click)="onChipStatus('no_show')">No-show<span class="chip-filtro-count">{{ resumo?.noShow ?? 0 }}</span></button>
  <button type="button" class="chip-filtro" [ngClass]="semAlocacaoAtivo ? 'chip-filtro--active' : ''"
    (click)="onChipSemAlocacao()" matTooltip="Falta motorista ou veículo (ou os dois) — não é uma cor do farol.">
    Sem alocação<span class="chip-filtro-count">{{ resumo?.semAlocacao ?? 0 }}</span>
  </button>
</div>

<div class="mt-4">
  @if (!loading) {
    @if (itemsList.length > 0) {
      <div class="tab-overflow overflow-auto w-[100%]">
        <table-list-monitoring-os
          [dataSource]="itemsList"
          [agora]="agora"
          (editarOs)="editarOs($event)"
          (verPassageiros)="viewPassengers($event)"
          (mensagemMotorista)="viewMensagemMotorista($event)"
          (alterarMotorista)="alterarMotorista($event)"
          (alterarVeiculo)="alterarVeiculo($event)"
          (ocorrencias)="viewOccurrences($event)"
          (progresso)="viewProgress($event)"
          (confirmarFase)="onConfirmarFase($event)"
          (marcarNoShow)="onMarcarNoShow($event)"
          (desmarcarNoShow)="onDesmarcarNoShow($event)"
          (confirmarEnvio)="onConfirmarEnvio($event)"
          (desfazerEnvio)="onDesfazerEnvio($event)"
          (confirmarAtribuicao)="onConfirmarAtribuicao($event)"
          (recusarAtribuicao)="onRecusarAtribuicao($event)"
          (historico)="onHistorico($event)"
          (cancelarOs)="onCancelarOs($event)"
          (sortChange)="onSort($event)"
        />
      </div>
    } @else {
      <div><h3 class="text-center">Nenhum registro encontrado.</h3></div>
      @if (codigoOs && aba === 'ativos') {
        <!-- Código certo e lista vazia se lê como "essa OS não existe" — serviço já
             terminado só aparece na outra aba. -->
        <div class="text-center text-sm text-gray-500">
          Se o serviço já terminou, procure o código na aba Finalizados.
        </div>
      }
    }
  } @else {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-paginator [hidden]="itemsList.length == 0 || loading" [length]="numberRows" [pageSize]="rows"
    [pageIndex]="page - 1" [pageSizeOptions]="[30, 50, 80, 100]" (page)="onPageEvent($event)">
  </mat-paginator>
</div>

<div class="regras-farol">
  <div class="regras-farol-titulo">Regras do farol — cada bolinha é uma fase, com alerta por antecedência</div>
  <div class="regras-farol-grid">
    <div class="regra-card">
      <div class="regra-card-titulo">1 · Motorista notificado</div>
      <div class="regra-card-linha regra-card-linha--alerta">Amarelo · janela de alerta</div>
      <div class="regra-card-linha regra-card-linha--critico">Vermelho · janela crítica</div>
      <div class="regra-card-linha regra-card-linha--ok">Verde · confirmação de envio registrada</div>
    </div>
    <div class="regra-card">
      <div class="regra-card-titulo">2 · Motorista confirmado</div>
      <div class="regra-card-linha regra-card-linha--alerta">Amarelo · janela de alerta</div>
      <div class="regra-card-linha regra-card-linha--critico">Vermelho · janela crítica</div>
      <div class="regra-card-linha regra-card-linha--ok">Verde · confirmou "CIENTE E DE ACORDO"</div>
    </div>
    <div class="regra-card">
      <div class="regra-card-titulo">3 · Motorista no local</div>
      <div class="regra-card-linha regra-card-linha--alerta">Amarelo · janela de alerta</div>
      <div class="regra-card-linha regra-card-linha--critico">Vermelho · janela crítica</div>
      <div class="regra-card-linha regra-card-linha--ok">Verde · motorista no local</div>
    </div>
    <div class="regra-card">
      <div class="regra-card-titulo">4 · Passageiro embarcado</div>
      <div class="regra-card-linha regra-card-linha--alerta">Amarelo · janela de alerta</div>
      <div class="regra-card-linha regra-card-linha--critico">Vermelho · janela crítica</div>
      <div class="regra-card-linha regra-card-linha--ok">Verde · PAX embarcado</div>
    </div>
    <div class="regra-card">
      <div class="regra-card-titulo">5 · Serviço finalizado</div>
      <div class="regra-card-linha text-gray-400">Sem previsão de término hoje — a fase fica pendente até alguém confirmar.</div>
      <div class="regra-card-linha regra-card-linha--ok">Verde · serviço finalizado</div>
    </div>
  </div>
  <div class="regras-farol-nota">
    Confirmação manual: clique em qualquer bolinha para confirmar a fase quando o motorista não usar o app.
  </div>
</div>
